// extracted by mini-css-extract-plugin
export default {"write":"Add_write__Pk1ok","input":"Add_input__615XU","btn":"Add_btn__vo0JO"};